module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.13055/assets/images/workflows-template-image.png"